import React from 'react'
import { Grid } from '@mui/material'

import { ButtonResetTableFilters, DateRange } from '@/components'
import { b2cRegistryActions, B2CRegistryTableState, useB2CRegistryState } from '@/stores/slices/b2c-registry-slice.ts'
import { useAppDispatch } from '@/stores/hooks.ts'

import { B2CRegistryStateFilter } from './b2c-registry-state-filter.tsx'

const resettableKeyFilters: (keyof B2CRegistryTableState)[] = ['dateTo', 'dateFrom', 'b2cState']

export const B2CRegistryFilters = (): React.ReactElement => {
  const { dateRange, resettableStateFilters } = useB2CRegistryState(resettableKeyFilters)
  const dispatch = useAppDispatch()

  const handleDateChange = (value: [string?, string?]) => {
    dispatch(b2cRegistryActions.setFilter({ filterKey: 'dateFrom', filterValue: value[0] }))
    dispatch(b2cRegistryActions.setFilter({ filterKey: 'dateTo', filterValue: value[1] }))
  }

  const resetFilters = () => dispatch(b2cRegistryActions.resetFilters(resettableKeyFilters))

  return (
    <Grid container spacing={2} flexDirection="row">
      <Grid item xs={12} lg={3}>
        <B2CRegistryStateFilter />
      </Grid>
      <Grid item xs={12} lg={6}>
        <DateRange initialRange={dateRange} onChange={handleDateChange} />
      </Grid>
      <Grid item xs={12} lg={3}>
        <ButtonResetTableFilters stateFilters={resettableStateFilters} onResetFilters={resetFilters} />
      </Grid>
    </Grid>
  )
}
